import { render } from "./waiting_time.vue?vue&type=template&id=140cec4e"
import script from "./waiting_time.vue?vue&type=script&lang=js"
export * from "./waiting_time.vue?vue&type=script&lang=js"

import "./waiting_time.vue?vue&type=style&index=0&id=140cec4e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__